class RegulatoryOrderService {
  get_data(page, data) {
    return axios.post('general/regulatory-violation-order?page=' + page, data)
  }
  get(id) {
    return axios.get('general/regulatory-violation-order/' + id)
  } 
  add(data) {
    return axios.post('general/regulatory-violation-order/store', data)
  }
  edit(id, data) {
    return axios.post('general/regulatory-violation-order/update/' + id, data)
  }
  delete(id) {
    return axios.delete('general/regulatory-violation-order/delete/' + id)
  }

}
export default new RegulatoryOrderService();